'use client';
import { useClientOnlyMediaQuery } from '~/common/hooks/use-client-only-media-query';
import { useVipStateWithCache } from '~/common/hooks/use-vip-state-with-cache';
import { IMobileAdUnitInfo } from '~/utils/i-mobile-constants';
import { Media } from '~/utils/styles/enums';
import { Box } from '@styled-system/jsx';
import { useInitAd } from './use-init-ad';
import './styles.css';

const PC_AD_UNIT: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_803,
  asid: 1_892_643,
  type: 'banner',
  display: 'interstitial',
  elementid: 'im-fb5e41bc9b5243da83cee1e92b3876d0',
};

const PC_SENSITIVE_AD_UNIT: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_744,
  asid: 1_894_546,
  type: 'banner',
  display: 'interstitial',
  elementid: 'im-ae630cf3c2204b398c604d2c1471a1ec',
};

const SP_AD_UNIT: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_802,
  asid: 1_868_553,
  type: 'banner',
  display: 'interstitial',
  elementid: 'im-616681f1376d4a8fb5dcf00e36d0596b',
};

const SP_SENSITIVE_AD_UNIT: IMobileAdUnitInfo = {
  pid: 81_732,
  mid: 568_744,
  asid: 1_894_546,
  type: 'banner',
  display: 'interstitial',
  elementid: 'im-ae630cf3c2204b398c604d2c1471a1ec',
};

const IMobileInterstitial = ({ adUnit }: { adUnit: IMobileAdUnitInfo }) => {
  useInitAd(adUnit);
  return <Box id={adUnit.elementid} zIndex="god"></Box>;
};

type Props = { canShowGoogleAd: boolean };

export const IMobileInterstitialContainer = ({ canShowGoogleAd }: Props) => {
  const { storedVipState } = useVipStateWithCache();
  const screenLarge = useClientOnlyMediaQuery(Media.LARGE);

  if (storedVipState || typeof screenLarge === 'undefined') return null;

  const adUnit = canShowGoogleAd
    ? screenLarge
      ? PC_AD_UNIT
      : SP_AD_UNIT
    : screenLarge
    ? PC_SENSITIVE_AD_UNIT
    : SP_SENSITIVE_AD_UNIT;

  return <IMobileInterstitial adUnit={adUnit} />;
};
